// apiSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_END_POINT } from "config";

const TOKEN_KEY = "token";
const getToken = () =>
  sessionStorage.getItem(TOKEN_KEY) ?? localStorage.getItem(TOKEN_KEY);

// 1) raw baseQuery: sets base URL + Authorization (only if token exists)
const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_END_POINT,
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    } else {
      headers.delete("Authorization"); // avoid sending "Bearer null"
    }
    return headers;
  },
});

// 2) wrapper: catch 401s once for all endpoints
const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  const status = result?.error?.status;
  const message =
    result?.error?.data?.message || result?.error?.data?.error || "";

  if (status === 401 || /Unauthenticated\.|sid|concurrent/i.test(message)) {
    // clear tokens and redirect
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY);
    // If you have a redux logout action, dispatch it here:
    // api.dispatch(authLoggedOut());
    if (window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
  }

  return result;
};

const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    // GET /company
    getAllCompany: builder.query({
      query: () => ({ url: "company", method: "GET" }),
    }),

    // POST /company
    addCompany: builder.mutation({
      query: (body) => ({ url: "company", method: "POST", body }),
    }),

    // POST /account/TermsConditionAccepted
    updateTermsConditions: builder.mutation({
      query: (body) => ({
        url: "account/TermsConditionAccepted",
        method: "POST",
        body,
      }),
    }),
  }),
});

export default apiSlice;
export const {
  useGetAllCompanyQuery,
  useAddCompanyMutation,
  useUpdateTermsConditionsMutation,
} = apiSlice;
